import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useGenerateMagicLinkMutation = (
  options?: UseMutationOptions<
    { magicLink: string },
    AxiosError,
    { userId: string }
  >
) => {
  return useMutation<{ magicLink: string }, AxiosError, { userId: string }>({
    ...options,
    mutationFn: async ({ userId }) => {
      const res = await httpClient.post(
        `/admin/users/${userId}/generate-magic-link`,
        {
          userId,
        }
      )
      return res.data
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      await navigator.clipboard.writeText(data.magicLink)
      showSuccessNotification({
        title: `Magic link generated `,
        message: `Magic link generated and copied to clipboard : ${data.magicLink}`,
      })
    },
    onError: (error, variables, onMutateResult, context) => {
      options?.onError?.(error, variables, onMutateResult, context)
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage:
          "An error occurred while generating the magic link",
        showNotification: true,
        error: error as Error,
      })
    },
  })
}
